import {MOBILE_WINDOW_WIDTH_MAX} from "../config/config";

export function isMobileWidth() {
    return window.innerWidth < MOBILE_WINDOW_WIDTH_MAX;
}